import React, { Component } from 'react'
import { connect } from 'react-redux'
import Moment from 'moment'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import PanoramaFishEye from 'material-ui/svg-icons/image/panorama-fish-eye'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import dataActions from 'actions/dataActions'
import formatPhone from 'utils/formatPhone'
import { doc, dirtyRead, currentDate } from 'selectors/common'
import { householdTenants } from 'selectors/tenant'
import { lastTenantLease } from 'selectors/leases'
import Household from './Household'
import Leases from './Leases'
import Ledger from '../leaseForm/Ledger'
import HeadOfHouseholdCombobox from './HeadOfHouseholdCombobox'

let select = dirtyRead(
	(state, props) => ({
		  tenant: doc(state, props.objectID)
		, householdTenants: householdTenants(state, props)
		, lastTenantLease: lastTenantLease(state, props)
	  , currentDate: currentDate(state)
	})
)

export class LeftSide extends Component{
	render(){
		const { props } = this
		const household = props.householdTenants && props.householdTenants.length > 1;
		const { lastTenantLease } = props;
		let hasActiveLease = false;

		if (lastTenantLease){
			const currentDate = Moment(props.currentDate);
			const dateTill = lastTenantLease.breakDate ? Moment(lastTenantLease.breakDate) : Moment(lastTenantLease.dateTill);
			hasActiveLease = dateTill > currentDate;
		}

		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<div style={{clear:"both", width:"100%"}}>
					<div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-10px", top:"7px"}}>
							<img
								src={".." + "/static/img/svg-icon/tenants_green.svg"}
								className="left-navigation-icons"
								style={{
									height: "14px"
								  , position: "relative"
								  , top: "-5px"
								  , left: "0px"
								  , display: ""
								}}
							/>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 104px)"}}
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							hintText="Tenant"
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							defaultValue={(props.tenant.tenant || props.tenant.firstName)?props.tenant.tenant || (props.tenant.firstName||"") + " " + (props.tenant.lastName ||""):""}
							key={props.tenant.tenant || props.tenant.firstName + " " + props.tenant.lastName}
							onBlur={(evt)=>{
								props.STAGE({_id: props.objectID, tenant: evt.target.value})
							}}
						/>
					</div>
					<div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-10px", top:"7px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>call</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 104px)"}}
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							hintText="Phone"
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={props.tenant.phoneNumber || ""}
							key={props.tenant.phoneNumber}
							onBlur={(evt)=>{
								let phone = evt.target.value && evt.target.value.match(/[0-9]/g) ? formatPhone(evt.target.value) : ''
								props.STAGE({_id: props.objectID, phoneNumber: phone.substring(1)})
							}}
						/>
					</div>
					<div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-10px", top:"7px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>email</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 104px)"}}
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							hintText="Email"
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={props.tenant.email || ""}
							key={props.tenant.email}
							onBlur={(evt)=>{
								props.STAGE({_id: props.objectID, email: evt.target.value})
							}}
						/>
					</div>
						{(!hasActiveLease || household) && <HeadOfHouseholdCombobox objectID={props.objectID} />}
						{!props.tenant.parentID && <Leases tenantID={props.objectID} />}
					</div>
				</div>
				{!props.tenant.parentID && household && <Household objectID={props.objectID} />}
				<Ledger tenantID={props.objectID} width={props.width}/>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/tenantForm/LeftSide.js